export function validateIPAddress(value) {
  // eslint-disable-next-line max-len
  if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(value)) {
    return true;
  }
  return false;
}

export function correctDomainName(value) {
  const regex = /[^a-z0-9-._://]/gi;
  return value.replace(regex, '');
}

export function domainsMatched(domain1, domain2) {
  const getCompressedDomain = url => {
    const domain = url.split('://').pop();
    return domain.replace(/\W/gi, '');
  };

  return getCompressedDomain(domain1) === getCompressedDomain(domain2);
}

export function getSecurityRiskDescription(riskText) {
  return riskText
    ?.substring(riskText.indexOf(':') + 1, riskText.length)
    .trim()
    .toLowerCase();
}

export function getSecurityRiskCode(riskText) {
  return riskText?.substring(0, riskText.indexOf(':'));
}

export function isEmptyString(str) {
  return (typeof str === 'string' && str.trim().length === 0);
}
